<template>
  <div>
    <div v-if="!isCreatorMenu">
      <div class="dropdown is-hoverable" :class="{'is-up': post, 'is-right': !post}">
        <div class="dropdown-trigger share-dropdown" :class="{'button is-small is-rounded is-outlined' : $isEngCom}">
          <span class="has-icon share-btn"
                :class="{'share-btn-light': post && $isEngCom }"
                aria-haspopup="true" aria-controls="dropdown-menu">
            <i v-if="!newIcon" class="share-glyph fal fa-share-alt"/>
            <span class="icon-container">
              <i v-if="newIcon" class="fal fa-share new-icon"/>
            </span>
          <span v-if="newIcon" class="new-icon-text">Share</span>
            <span class="share-button-text" :class="{'is-uppercase':!post}" >{{buttonTitle}}</span>
          </span>
        </div>
        <div class="dropdown-menu gtm-fb-share-button-track" id="dropdown-menu" role="menu">
          <div class="dropdown-content is-flex gtm-fb-share-button-track">
            <div v-if="!isPrivate && !isPostPrivate">
              <social-sharing :url="getShareURL('facebook')" @open="track('facebook')"
                  :title="project.title"
                  :description="project.description"
                  :quote="project.title"
                  :hashtags="hashTag"
                  v-cloak inline-template
                  class="gtm-proj-facebook dropdown-item gtm-fb-share-button-track">
              <div class="share-icon share-facebook gtm-proj-facebook gtm-fb-share-button-track">
                  <network network="facebook" class="gtm-fb-share-button-track">
                    <span><i class="fab fa-facebook gtm-fb-share-button-track"></i></span>
                    &nbsp;&nbsp;&nbsp;&nbsp;Facebook
                  </network>
              </div>
              </social-sharing>
              <social-sharing :url="getShareURL('twitter')" @open="track('twitter')"
                  :title="project.title"
                  :description="project.description"
                  :quote="project.title"
                  :hashtags="hashTag"
                  v-cloak inline-template
                  class="gtm-proj-twitter dropdown-item gtm-twitter-share">
              <div class="share-icon share-twitter gtm-proj-twitter gtm-twitter-share">
                  <network network="twitter" class="gtm-twitter-share">
                    <span><i class="fab fa-twitter gtm-twitter-share"></i></span>
                    &nbsp;&nbsp;&nbsp;&nbsp;Twitter
                  </network>
              </div>
              </social-sharing>
              <social-sharing :url="getShareURL('linkedin')" @open="track('linkedin')"
                  :title="project.title"
                  :description="project.description"
                  :quote="project.title"
                  :hashtags="hashTag"
                  v-cloak inline-template
                  class="gtm-proj-linkedin dropdown-item gtm-linkedin-share">
              <div class="share-icon share-linkedin gtm-proj-linkedin gtm-linkedin-share">
                  <network network="linkedin" class="gtm-linkedin-share">
                    <span><i class="fab fa-linkedin gtm-linkedin-share"></i></span>
                    &nbsp;&nbsp;&nbsp;&nbsp;Linkedin
                  </network>
              </div>
              </social-sharing>
              <hr class="dropdown-divider">
              <a :href="mailTo" class="dropdown-item" @click="track('mail')">
                <span><i class="fal fa-envelope"></i></span>{{ $t("projectPage.mail") }}
              </a>
            </div>
            <a class="dropdown-item" @click="toggleLinkModal">
              <span><i class="fal fa-link"></i></span>{{ $t("projectPage.link") }}
            </a>
          </div>
        </div>

    <hr v-if="isCreatorMenu" class="dropdown-divider">
    <div v-if="isCreatorMenu" class="dropdown-item">
      <social-sharing :url="getShareURL('facebook')"
          :title="project.title"
          :description="project.description"
          :quote="project.title"
          :hashtags="hashTag"
          v-cloak inline-template
          class="gtm-proj-facebook">
        <div class="share-icon share-facebook gtm-proj-facebook">
          <network network="facebook">
            <span><i class="fab fa-facebook"></i></span>
            &nbsp;&nbsp;&nbsp;&nbsp;Facebook
          </network>
        </div>
      </social-sharing>
    </div>
    <div v-if="isCreatorMenu" class="dropdown-item">
      <social-sharing :url="getShareURL('twitter')"
          :title="project.title"
          :description="project.description"
          :quote="project.title"
          :hashtags="hashTag"
          v-cloak inline-template
          class="gtm-proj-twitter">
        <div class="share-icon share-twitter gtm-proj-twitter">
          <network network="twitter">
            <span><i class="fab fa-twitter"></i></span>
            &nbsp;&nbsp;&nbsp;&nbsp;Twitter
          </network>
        </div>
      </social-sharing>
    </div>
    <div v-if="isCreatorMenu" class="dropdown-item">
      <social-sharing :url="getShareURL('linkedin')"
          :title="project.title"
          :description="project.description"
          :quote="project.title"
          :hashtags="hashTag"
          v-cloak inline-template
          class="gtm-proj-linkedin">
        <div class="share-icon share-linkedin gtm-proj-linkedin">
          <network network="linkedin">
            <span><i class="fab fa-linkedin"></i></span>
            &nbsp;&nbsp;&nbsp;&nbsp;Linkedin
          </network>
        </div>
      </social-sharing>
    </div>
    <hr v-if="isCreatorMenu" class="dropdown-divider">
    <a v-if="isCreatorMenu" :href="mailTo" class="dropdown-item">
      <span><i class="fal fa-envelope"></i></span>
      {{ $t("projectPage.mail") }}
    </a>
    <a v-if="isCreatorMenu" class="dropdown-item" @click="toggleLinkModal">
      <span><i class="fal fa-link"></i></span>
      {{ $t("projectPage.link") }}
    </a>
    <hr v-if="isCreatorMenu" class="dropdown-divider">

    <modal-custom v-if="seenLinkModal" :hasFooter="true" :footerText="copySuccess" :hasClose="true" @modalSuccess="copyLink" @modalCancel="toggleLinkModal" @modalClose="toggleLinkModal"
      :title="'Share this link'" :hasInput="true" :filledInput="getShareURL('shareLink')" :successText="'Copy'" :cancelText="'Done'">
    </modal-custom>
      </div>
    </div>
  </div>
</template>

<script>
import SocialSharing from 'vue-social-sharing'
import ModalCustom from '@/components/Modals/Custom'

import auth from '@/mixins/auth'

import socket from '@/libs/socket'

export default {
  components: {
    SocialSharing,
    ModalCustom
  },

  mixins: [auth],

  props: ['project', 'post', 'isCreatorMenu', 'newIcon', 'isPrivate', 'isPostPrivate'],

  data: function () {
    return {
      seenLinkModal: false,
      copySuccess: ''
    }
  },

  computed: {
    mailTo: function () {
      return this.project ? `mailto:?body=${encodeURIComponent(this.getShareURL('email'))}&subject=${this.project.title}` : ''
    },
    referralCode: function () {
      return this.$store.getters.referralCode
    },
    buttonTitle: function () {
      if (!this.post || this.$isEngCom) {
        return 'Share'
      }
    },
    hashTag: function () {
      if (this.$isEngCom) {
        return 'engineeringcom'
      } else {
        return 'makeprojects'
      }
    }
  },
  methods: {
    getShareURL: function (network) {
      const utmSource = this.getUtmSource(network)
      const storyOrProject = this.$isStories ? 'story' : 'project'
      let projectID = null
      if (this.post.project && this.post.project.id) {
        projectID = this.post.project.id
      }
      let url = `${this.$webRoot}/${storyOrProject}/${this.$route.params.id ? this.$route.params.id : projectID}?utm_source=${utmSource}`
      if (this.post) {
        url = `${url}&postID=${this.post.id}`
      }

      if (this.referralCode) {
        url = `${url}&rc=${this.referralCode}`
      }

      // Condition for new TV page on Engcom
      if (storyOrProject === 'story' && (this.$route.path.includes('/story'))) {
        url = `${this.$webRoot}/${storyOrProject}/${this.$route.params.id}`
      }
      return url
    },
    toggleLinkModal: function () {
      this.seenLinkModal = !this.seenLinkModal
      this.copySuccess = ''
      if (this.seenLinkModal) {
        this.track('link')
      }
    },
    copyLink: function () {
      const copyText = document.getElementById('inputField')
      copyText.focus()
      copyText.setSelectionRange(0, this.getShareURL('shareLink').length)
      document.execCommand('copy')
      this.copySuccess = 'Copied to clipboard'
    },
    track: function (network) {
      socket.share(network, this.project.id, 'project')
    },
    getUtmSource: function (network) {
      return `${network}_share_${this.project.id}`
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  .share-btn {
    font-size: 0.7rem;
    font-weight: 500;
  }
  .share-btn-light {
    font-weight: 400;
  }
  .share-button-text {
    margin-left: 0.25rem;
  }
  .share-glyph {
    font-size: 0.8rem;
  }
  .share-btn:hover{
    color: $primary;
  }
  .share-dropdown:hover {
    cursor: pointer;
    color: $primary;
  }
  .dropdown-menu {
    width: 140px;
    min-width: 0;
    position: absolute;
    left: -62px;
  }
  .dropdown-content {
    flex-direction: column;
    max-width: 140px;
    user-select: none;
    .dropdown-item span {
      margin-right: 1.1rem;
    }
    .dropdown-item {
      display: flex;
      width: 140px;
    }
    .dropdown-item:hover {
      color: $primary;
    }
    .share-icon:hover, .dropdown-item:hover {
      background-color: var(--background-fifth);
    }
  }

  .new-icon {
    font-size: 0.85rem;
    padding-right: 0.25rem;
    padding-left: 0.25rem;
  }
  .new-icon-text {
    font-size: 1rem;
  }

</style>
